<template>
    <v-container>
      <mensajeSistema></mensajeSistema>

        <!-- filtros por selects -->
      <v-row>
        <v-col cols="12" md="4">
          <v-autocomplete
            v-model="selectedNivel"
            :items="niveles"
            label="Nivel"
            item-text="desc_nivel"
            item-value="id"
            @change="getGrados(selectedNivel)"
            clearable
          ></v-autocomplete>
        </v-col>
  
        <v-col cols="12" md="4">
          <v-autocomplete
            v-model="selectedGrado"
            :items="grados"
            label="Grado"
            item-text="desc_grado"
            item-value="id"
            @change="getSecciones"
            :disabled="!selectedNivel"
            clearable
          ></v-autocomplete>
        </v-col>
  
        <v-col cols="12" md="4">
          <v-autocomplete
            v-model="selectedSeccion"
            :items="secciones"
            label="Sección"
            item-text="nombre_seccion"
            item-value="id"
            @change="getEstudiantes"
            :disabled="!selectedGrado"
            clearable
          ></v-autocomplete>
        </v-col>
  

      </v-row>
  
      <!-- Search Bar y botòn de reset-->
      <v-row>
        <v-col cols="12" class="d-flex justify-end align-center">
            <v-tooltip right>
            <template v-slot:activator="{ on }">
                <v-btn text v-on="on" icon color="blue" @click="resetFilters()">
                <v-icon>fas fa-sync-alt</v-icon>
                </v-btn>
            </template>
            <span>Restablecer filtros </span>
            </v-tooltip>

            <v-text-field 
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar estudiante"
            single-line
            hide-details
            dense
            outlined
            class="ml-4"
            style="max-width: 250px;"
            ></v-text-field>
        </v-col>
      </v-row>
  
      <v-data-table
        :headers="headers"
        :items="filteredAndSearchedEstudiantes"
        class="elevation-1"
      >

        <template v-slot:item.postergacion_en_curso="{ item }">
          <v-chip
            :color="getColor(item.postergacion_en_curso)"
            dark
          >
            {{ item.postergacion_en_curso ? "Con postergación en curso" : "No tiene postergaciones" }}
          </v-chip>
        </template>
        <template v-slot:item.ver_postergaciones="{ item }">
          <v-tooltip bottom color="#1b1b1b">
              <template v-slot:activator="{ on }">
                  <v-btn v-on="on" class="btn_ver px-0 mx-0" fab x-small @click="verPostergaciones(item)">
                      <v-icon>fa-eye</v-icon>
                  </v-btn>
              </template>
              <span>VER POSTERGACIONES</span>
          </v-tooltip>
        </template>
        <template v-slot:item.acciones="{ item }">
          <v-btn color="primary" small @click="openDialog(item)">
            Postergar
          </v-btn>
        </template>
      </v-data-table>
  

      <ComunDialogComp v-model="dialogFormPosterg" max-width="600px" @close-modal="closeFormModal('dialogFormPosterg')">
        <template v-slot:title>
            Postergar Evaluaciones
        </template>

        <template v-slot:body>
            <v-form ref="form">
              <v-row>
                <v-col cols="12" md="6">
                  <v-menu
                    v-model="menuInicio"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="newStartDate"
                        label="Fecha de Inicio"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        required
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="newStartDate"
                      no-title
                      @input="menuInicio = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
  
                <v-col cols="12" md="6">
                  <v-menu
                    v-model="menuFin"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="newEndDate"
                        label="Fecha de Fin"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        required
                        :disabled="!newStartDate"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="newEndDate"
                      no-title
                      @input="menuFin = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="motivo"
                    label="Motivo de la postergación"
                    clearable
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
        </template>

        <template v-slot:actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="closeFormModal('dialogFormPosterg')">
              Cancelar
            </v-btn>
            <v-btn color="blue darken-2" text @click="editPostergacion" v-if="isEditing">
              Guardar cambios
            </v-btn>
            <v-btn color="blue darken-2" text @click="postergarEvaluacion" v-else>
              Guardar
            </v-btn>
        </template>
      </ComunDialogComp>


      <!-- vista de las postergaciones del student -->
      <ComunDialogComp v-model="dialog2" max-width="600px" @close-modal="()=>dialog2 = false">
        <template v-slot:title>
            Ver postergaciones
        </template>

        <template v-slot:body>
          <v-data-table
            :headers="headersPostergaciones"
            :items="postergacionesDelEstudiante"
            class="elevation-1"
            :item-class="getRowClass"
          >
            
            <template v-slot:no-data>
              <v-alert type="info" text>
                No hay postergaciones disponibles.
              </v-alert>
            </template>

            <template v-slot:item.ver_postergaciones="{ item }">
              <span v-if="item.motivo">{{ item.motivo }}</span>
              <span v-else>Sin motivo</span>
            </template>

            <template v-slot:item.editar_postergaciones ="{ item }">
                <v-tooltip bottom color="#1b1b1b">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="btn_editar px-0 mx-0" fab x-small @click="openEditDialog(item)">
                            <v-icon>fa-pencil-alt</v-icon>
                        </v-btn> 
                    </template>
                    <span>Editar postergación</span>
                </v-tooltip>
            </template>
          </v-data-table>
          
          <v-card flat class="mt-3 pa-3">
            <v-alert type="info" class="white--text blue lighten-1">
              <strong>Leyenda:</strong>
            </v-alert>
            <v-row class="d-flex align-center">
              <v-col cols="12" sm="4" class="d-flex align-center">
                <v-chip color="red" dark></v-chip> 
                <span class="ml-2">Postergaciones vencidas</span>
              </v-col>
              <v-col cols="12" sm="4" class="d-flex align-center">
                <v-chip color="green" dark></v-chip> 
                <span class="ml-2">Postergaciones en curso</span>
              </v-col>
              <v-col cols="12" sm="4" class="d-flex align-center">
                <v-chip color="blue" dark></v-chip> 
                <span class="ml-2">Postergaciones programadas</span>
              </v-col>
            </v-row>
          </v-card>

        </template>

        


        
      </ComunDialogComp>

    </v-container>
  </template>
  
  <script>
import ComunDialogComp from '../../../components/ComponentsEst/ComunDialogComp.vue';
import axios from "@/helpers/axios";
import { mapMutations } from 'vuex';


  export default {
    components: {
        ComunDialogComp,
    },
    data() {
      return {
        isEditing: false,
        id_postergacion: "",
        dataStorage: sessionStorage,
        dialogFormPosterg: false,
        menuInicio: false,
        menuFin: false,
        selectedEstudiante: null,
        newStartDate: '',
        newEndDate: '',
        motivo: '',
        selectedNivel: null,
        selectedGrado: null,
        selectedSeccion: null,
        search: '',
        estudiantes: [],
        niveles: [],
        grados: [],
        secciones: [],
        filteredEstudiantes: [],
        headers: [
          { text: 'Estudiante', value: 'full_name' },
          { text: 'Estado del estudiante', value: 'postergacion_en_curso' },
          { text: 'Ver postergaciones', value: 'ver_postergaciones', sortable: false },
          { text: 'Acciones', value: 'acciones', sortable: false }
        ],
        postergacionesDelEstudiante: [],
        dialog2: false,
        headersPostergaciones: [
          { text: 'Fecha Inicio', value: 'fecha_inicio' },
          { text: 'Fecha Fin', value: 'fecha_fin' },
          { text: 'Motivo', value: 'motivo' },
          { text: 'Editar postergación', value: 'editar_postergaciones' },
        ]
      };
    },
    computed: {
      filteredAndSearchedEstudiantes() {
        return this.estudiantes.filter(estudiante => 
        estudiante.full_name.toLowerCase().includes(this.search.toLowerCase())
        );
      }
    },
    methods: {
      ...mapMutations('mensajeSis', ['setEnviarMens']),

      async getNiveles() {
        try {
          const response = await axios.post(
            "/academico/asistenciaColegioNew/getNiveles",
            {
              id_colegio: this.dataStorage.id_colegio,
              id_ano_lectivo: this.dataStorage.id_ano_lectivo,
            }
          );
          this.niveles = response.data;
          await this.getEstudiantes();
        } catch (error) {
          console.log(error);
        }
      },

      async getGrados(nivelSelected) {
        try {
          const response = await axios.post(
            "/academico/asistenciaColegioNew/getGrados",
            {
              id_colegio: this.dataStorage.id_colegio,
              id_ano_lectivo: this.dataStorage.id_ano_lectivo,
              idNivel: nivelSelected,
            }
          );

          this.grados = response.data;
          await this.getEstudiantes(nivelSelected);
        } catch (error) {
          console.log(error);
        }
      },

      // eslint-disable-next-line no-unused-vars
      async getSecciones(gradoSelected) {
        try {
          const response = await axios.post(
            "/academico/asistenciaColegioNew/getSecciones",
            {
              id_colegio: this.dataStorage.id_colegio,
              id_ano_lectivo: this.dataStorage.id_ano_lectivo,
              idGrado: this.selectedGrado,
            }
          );

          this.secciones = response.data;
          await this.getEstudiantes();
          // await this.getEstudiantes(this.selectedGrado);
        } catch (error) {
          console.log(error);
        }
      },


      async getEstudiantes() {

        const params = {
          niv: this.selectedNivel,
          grad: this.selectedGrado,
          sec: this.selectedSeccion,
          onlyDate: this.getLocalTodayDate()
        };
        try {
          const response = await axios.get(
            `/evaluacion/postergacion/estudiantes/${this.dataStorage.id_colegio}`,
          {
            params
          });
          this.estudiantes = response.data.estudiantes;

        } catch (error) {
          console.error(error);
        }
      },

      async resetFilters() {
        this.selectedNivel = null;
        this.selectedGrado = null;
        this.selectedSeccion = null;
        this.search = '';
        this.motivo = '';
        await this.getEstudiantes();
      },

      openDialog(estudiante) {
        this.selectedEstudiante = estudiante;
        this.dialogFormPosterg = true;
      },

      async verPostergaciones(item) {
        await this.getPostergacionesByEstudiante(item.id_alumno);
        this.selectedEstudiante = item;
        this.dialog2 = true;
        
      },
      
      async postergarEvaluacion() {
        try {
          if (this.$refs.form.validate()) {
            const params = {
              id_alumno: this.selectedEstudiante.id_alumno,
              id_ano_lectivo: this.dataStorage.id_ano_lectivo,
              newStartDate: this.newStartDate,
              newEndDate: this.newEndDate,
              motivo: this.motivo,
              id_us: this.dataStorage.id,
              update_date: new Date()
            };
            // eslint-disable-next-line no-unused-vars
            const response = await axios.post("/evaluacion/postergacion/estudianteEval", params);
            
            this.dialogFormPosterg = false;
            this.selectedEstudiante = null;
            this.newStartDate = '';
            this.newEndDate = '';
            this.motivo = '';
            this.setEnviarMens({ tipo: "S", mensaje: 'Evaluaciones postergadas con éxito.', tiempo: null });
            await this.getEstudiantes();
          }
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: error.message.includes(400) ? "Escoja otra fecha" : "Error al generar postergación", tiempo: null })
        }
      },

      async getPostergacionesByEstudiante(id_alumno){
        try {
          
          const postgergacionesDelEstudiante = await axios.get(`/evaluacion/postergacion/postgergaciones/${id_alumno}/${this.dataStorage.id_ano_lectivo}`);
          
          this.postergacionesDelEstudiante = postgergacionesDelEstudiante.data.postergaciones;
        } catch (error) {
          console.log(error, "wqwqskimn");
          
          this.setEnviarMens({ tipo: "E", mensaje: 'Error al consultar postergaciones.', tiempo: null });
        }
      },
      getColor(estado) {
        return estado ? "green" : "grey"
      },
      getRowClass(item) {
        
        const today = this.getLocalTodayDate();
        
        const fechaInicio = item.fecha_inicio;
        const fechaFin = item.fecha_fin;

        
        if (fechaInicio > today) {
          return 'blue lighten-4';
        }
        if (fechaFin < today) {
          return 'red lighten-4';
        }
        
        if (fechaInicio <= today && fechaFin >= today) {
          return 'green lighten-4';
        }
      
        return '';
      },

      getLocalTodayDate() {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return today.toISOString().split('T')[0];
      },
      async editPostergacion(){
        try {
          const params = {
            newStartDate: this.newStartDate,
            newEndDate: this.newEndDate,
            motivo: this.motivo,
            id_us_m: this.dataStorage.id,
            id: this.id_postergacion,
            update_date: new Date().getTime()
          };
          // eslint-disable-next-line no-unused-vars
          const response = await axios.put("/evaluacion/postergacion/", params);

          this.dialogFormPosterg = false;
          // this.selectedEstudiante = null;
          this.newStartDate = '';
          this.newEndDate = '';
          this.motivo = '';
          this.id_postergacion = ''
          this.isEditing = false;
          this.setEnviarMens({ tipo: "S", mensaje: 'Postergación actualizada con éxito.', tiempo: null });
          await this.getEstudiantes();
          await this.getPostergacionesByEstudiante(this.selectedEstudiante.id_alumno);

        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: error.message.includes(400) ? "Escoja otra fecha" : "Error al generar postergación", tiempo: null })
        }
      },
      openCreateDialog() {
        this.isEditing = false;

        this.dialogFormPosterg = true;
      },
      openEditDialog(postergacion) {
        this.isEditing = true;
        this.newStartDate = postergacion.fecha_inicio;
        this.newEndDate = postergacion.fecha_fin;
        this.motivo = postergacion.motivo;
        this.id_postergacion = postergacion.id;
        this.dialogFormPosterg = true;
      },
      closeFormModal(dialog){
        
        this[dialog] = false;
        this.selectedEstudiante = null;
        this.newStartDate = '';
        this.newEndDate = '';
        this.motivo = '';
        this.id_postergacion = ''
        this.isEditing = false;
      },

    },
    async mounted() {
      await this.getNiveles();
      await this.getEstudiantes();
    }
  };
  </script>
  
  <style scoped>
  .v-data-table {
    margin-top: 20px;
  }
  
  .v-toolbar {
    margin-bottom: 20px;
  }
  </style>
  